/**
 * Moduły kolejnej fazy (spec 01 §12b, §13) — układ z makiety, ale bez
 * wymyślonych danych.
 *
 * Płace i deklaracje wyprowadziły się stąd, gdy dostały realny backend
 * (`Payroll.tsx` w Etapie 9, `Declarations.tsx` w Etapie 10) — i wypełniły się
 * bez zmian w układzie, dokładnie tak, jak obiecywał kontrakt `engineAvailable`.
 * Zostają katalog integracji i builder reguł płacowych: żadna z tych rzeczy nie
 * istnieje, więc ekran mówi to wprost [D19, D27].
 */
import { useTranslation } from 'react-i18next'
import { Badge, Card, InfoBanner, Plug, ProcessTimeline, StatusPill } from '@k1p4/ui'
import styles from './SoonModules.module.css'

/** Katalog integracji — żadna nie jest podłączona, więc żadna nie mówi „Połączono". */
const INTEGRATIONS = ['accounting', 'bank', 'mobywatel', 'ppk', 'zus', 'time'] as const

export function Integrations() {
  const { t } = useTranslation()

  return (
    <>
      <p className={styles.lead}>{t('hrIntegrations.lead')}</p>

      <InfoBanner tone="warning" className={styles.banner}>
        {t('hrIntegrations.emptyBody')}
      </InfoBanner>

      <div className={styles.catalog}>
        {INTEGRATIONS.map((key) => (
          <Card key={key} pad="md" className={styles.integration}>
            <div className={styles.integrationHead}>
              <span className={styles.integrationIcon} aria-hidden="true">
                <Plug size={18} />
              </span>
              <StatusPill tone="neutral">{t('hrIntegrations.statusNotConfigured')}</StatusPill>
            </div>
            <p className={styles.integrationTitle}>{t(`hrIntegrations.catalog.${key}`)}</p>
            <p className={styles.integrationDesc}>{t(`hrIntegrations.catalog.${key}Desc`)}</p>
            <Badge tone="warning">{t('hrIntegrations.statusSoon')}</Badge>
          </Card>
        ))}
      </div>
    </>
  )
}

/**
 * Builder reguł płacowych (spec 01 §12b) — kroki z makiety bez silnika, który
 * mógłby je wykonać, więc kreator jest opisany, a nie udawany.
 */
const RULE_STEPS = ['component', 'condition', 'formula', 'scope', 'test'] as const

export function RuleBuilder() {
  const { t } = useTranslation()
  return (
    <>
      <p className={styles.lead}>{t('hrRules.lead')}</p>

      <InfoBanner tone="warning" className={styles.banner}>
        {t('hrRules.soonBody')}
      </InfoBanner>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('hrRules.stepsTitle')}</h3>
        <Card pad="md">
          <ProcessTimeline
            tone="onLight"
            current={0}
            items={RULE_STEPS.map((step) => ({
              key: step,
              label: t(`hrRules.steps.${step}`),
              owner: t(`hrRules.steps.${step}Desc`),
            }))}
          />
        </Card>
      </section>
    </>
  )
}
